import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, Store, Radio } from 'lucide-react';
import { VerifiedBadge } from './VerifiedBadge';
import { api } from '../lib/api';
import { catLabel } from '../lib/categories';
import { imgSrc } from '../lib/cart';

export const TopSellers = () => {
  const [sellers, setSellers] = useState([]);
  useEffect(() => { api.get('/sellers/top').then(({ data }) => setSellers(data)).catch(() => {}); }, []);
  if (!sellers.length) return null;
  return (
    <section className="w-full max-w-7xl mx-auto px-4 sm:px-6 pb-12" data-testid="top-sellers">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-5">
        <h2 className="font-display text-2xl sm:text-3xl font-bold flex items-center gap-2"><Store className="h-6 w-6 text-[#E8B84A]" />Nos boutiques</h2>
        <Link to="/shop" className="text-sm text-[#F5D98B] hover:text-white font-bold">Toutes les boutiques</Link>
      </div>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1 snap-x">
        {sellers.map((s) => (
          <Link key={s.user_id} to={s.live_id ? `/live/${s.live_id}` : `/seller/${s.user_id}`} data-testid={`top-seller-${s.user_id}`}
            className="group snap-start shrink-0 w-56 card-elev rounded-2xl p-4 hover:border-amber-500/50 transition">
            <div className="flex items-center gap-3">
              <div className="relative">
                {(s.shop_logo || s.picture) ? <img src={imgSrc(s.shop_logo || s.picture)} alt="" className="h-12 w-12 rounded-full object-cover" />
                  : <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-700 to-sky-400 grid place-items-center font-display font-extrabold text-lg">{(s.shop_name || s.name || '?')[0]}</div>}
                {s.live_id && <span className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full bg-rose-600 border-2 border-slate-900 animate-pulse" />}
              </div>
              <div className="min-w-0">
                <div className="font-bold truncate flex items-center gap-1.5">{s.shop_name || s.name}<VerifiedBadge verified={s.verified} testId={`verified-top-${s.user_id}`} /></div>
                <div className="text-xs text-slate-400">{catLabel(s.main_category)}</div>
              </div>
            </div>
            <div className="mt-3 flex items-center justify-between text-xs">
              <span className="inline-flex items-center gap-1 text-amber-400 font-semibold" data-testid={`top-seller-rating-${s.user_id}`}>
                <Star className="h-3.5 w-3.5 fill-amber-400" />{s.avg_rating ?? '—'}<span className="text-slate-500 font-normal">({s.reviews_count})</span>
              </span>
              <span className="text-slate-400">{s.products_sold} vendu{s.products_sold > 1 ? 's' : ''}</span>
            </div>
            {s.live_id && <div className="mt-2 inline-flex items-center gap-1 text-[10px] font-bold text-rose-400"><Radio className="h-3 w-3" />EN DIRECT MAINTENANT</div>}
          </Link>
        ))}
      </div>
    </section>
  );
};
